import type { FilterParams } from "./tools";

export const toolKeys = {
  base: () => ["tools", "v1"] as const,
  list: (filterParams?: FilterParams) =>
    [...toolKeys.base(), "list", filterParams] as const,
  infiniteList: (filterParams?: FilterParams) =>
    [...toolKeys.base(), "infiniteList", filterParams] as const,
  filterOptions: (filterParams?: FilterParams) =>
    [...toolKeys.base(), "filterOptions", filterParams] as const,
  responsibleEmployees: () =>
    [...toolKeys.base(), "responsibleEmployees"] as const,
  managers: () => [...toolKeys.base(), "managers"] as const,
  manufacturers: () => [...toolKeys.base(), "manufacturers"] as const,
  additionalData: () => [...toolKeys.base(), "additionalData"] as const,
  detail: (id: string) => [...toolKeys.base(), "detail", id] as const,
  history: (id: string) => [...toolKeys.detail(id), "history"] as const,
  inventoryHistory: (id: string) =>
    [...toolKeys.detail(id), "inventoryHistory"] as const,
  inventoryBase: () => [...toolKeys.base(), "inventory"] as const,
  infiniteInventory: (filterParams?: FilterParams) =>
    [...toolKeys.inventoryBase(), filterParams] as const,
  inventoryFilterOptions: (filterParams?: FilterParams) =>
    [...toolKeys.inventoryBase(), "filterOptions", filterParams] as const,
  inventoryDetail: (id: string) =>
    [...toolKeys.inventoryBase(), "inventoryDetail", id] as const,
  inventoryPhoto: (photoId: string) => ["inventoryPhoto", photoId] as const,
  inventoryDownloadPhotoUrl: (photoId: string) =>
    [
      ...toolKeys.inventoryBase(),
      "inventoryDownloadPhotoUrl",
      photoId,
    ] as const,

  updateToolMutationKey: ["updateToolMutation"] as const,
  assignToolMutationKey: ["assignToolMutation"] as const,
  rejectToolMutationKey: ["rejectToolMutation"] as const,
  makeToolAvailableMutationKey: ["makeToolAvailableMutation"] as const,
  takeToolMutationKey: ["takeToolMutation"] as const,
  returnToolMutationKey: ["returnToolMutation"] as const,
};
